export default {"src":"/_next/static/media/icon-allHouses.952650a7.svg","height":30,"width":28,"blurWidth":0,"blurHeight":0};